/* ------------------------------------------------------------------
   announcement-bar-autoplay.js
   Autoplay remains unchanged in behavior. The important fix is the
   same-element Shopify section selectors used for sticky height.
------------------------------------------------------------------ */

(() => {
  const ROOT = document.documentElement;

  function getSlideshow(scope = document) {
    return scope.querySelector('slideshow-component.announcement-bar-slider-component');
  }

  /* Shopify section classes are on the same wrapper element, not on
     nested descendants. */
  function getAnnouncementSection() {
    return document.querySelector(
      '.announcement-bar-section.shopify-section-group-header-group'
    );
  }

  function updateStickyOffset() {
    const announcementSection = getAnnouncementSection();

    if (!announcementSection) {
      ROOT.style.setProperty('--announcement-bar-height', '0px');
      return;
    }

    const announcementBar = announcementSection.querySelector(
      '[data-announcement-sticky]'
    );

    const isSticky =
      announcementBar &&
      announcementBar.dataset.announcementSticky === 'true';

    const height = isSticky
      ? announcementSection.getBoundingClientRect().height
      : 0;

    ROOT.style.setProperty(
      '--announcement-bar-height',
      `${Math.ceil(height)}px`
    );
  }

  function bindAutoplay(scope = document) {
    const slideshow = getSlideshow(scope);
    if (!slideshow) return;

    const slider = slideshow.querySelector('.slider');
    const nextButton = slideshow.querySelector('.slider-button--next');
    if (!slider || !nextButton) return;
    if (slider.dataset.autoplay !== 'true') return;
    if (slideshow.dataset.autoplayInitialized === 'true') return;

    slideshow.dataset.autoplayInitialized = 'true';

    const speed = (Number(slider.dataset.speed) || 5) * 1000;
    let timer = null;

    function triggerNext() {
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      if (slider.scrollLeft >= maxScrollLeft - 2) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        nextButton.click();
      }
    }

    function start() {
      if (timer) clearInterval(timer);
      timer = window.setInterval(triggerNext, speed);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    start();
    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);
    slideshow.addEventListener('touchstart', stop, { passive: true });
    slideshow.addEventListener('touchend', start, { passive: true });
    slideshow.addEventListener('focusin', stop);
    slideshow.addEventListener('focusout', start);
  }

  function init(scope = document) {
    bindAutoplay(scope);
    updateStickyOffset();
  }

  let resizeTimer;
  function scheduleOffsetUpdate() {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(updateStickyOffset, 100);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  window.addEventListener('load', () => init(document));
  window.addEventListener('resize', scheduleOffsetUpdate);

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:reorder', () => init(document));
  document.addEventListener('shopify:section:select', () => init(document));
  document.addEventListener('shopify:block:select', () => init(document));
})();
